<div id="ckm-listing-sort-container">
    <p id="sort-by-label">
        {{ 'tableSettings.sortColumnsBy' | translate }}:
        <app-info-overlay
            overlayId="order-list-sort-title"
            overlayAreaLabel="tableSettings.sortBy.tooltipAreaLabel"
            [iconSize]="'large'">
            <div class="sort-info-overlay-container">
                <p id="sort-info-overlay-title">{{ 'tableSettings.sortBy.infoTitle' | translate }}</p>
                <p id="sort-info-overlay-subtitle">{{ 'tableSettings.sortBy.infoSubtitle' | translate }}</p>

                <ul>
                    <li id="sort-info-overlay-step1">
                        <span>{{ 'tableSettings.sortBy.infoStep1' | translate }}:</span>
                        {{ 'tableSettings.sortBy.infoStep1Text' | translate }}
                    </li>
                    <li id="sort-info-overlay-step2">
                        <span>{{ 'tableSettings.sortBy.infoStep2' | translate }}:</span>
                        {{ 'tableSettings.sortBy.infoStep2Text' | translate }}
                    </li>
                </ul>

                <p id="sort-info-overlay-note">{{ 'tableSettings.sortBy.infoNote' | translate }}</p>
            </div>
        </app-info-overlay>
    </p>

    <div class="sort-by-table">
        <div class="table-header">
            <div class="table-cell move">{{ 'tableSettings.sortBy.move' | translate }}</div>
            <div class="table-cell columns">{{ 'tableSettings.sortBy.columns' | translate }}</div>
            <div class="table-cell sort">{{ 'tableSettings.sortBy.sort' | translate }}</div>
            @if (canRemoveColum) {
                <div class="table-cell remove">
                    {{ 'tableSettings.sortBy.remove' | translate }}
                </div>
            }
        </div>

        <div class="table-body">
            <p-orderList
                [dragdrop]="true"
                (onReorder)="changeSortPriority()"
                [value]="selectedColumns"
                #orderList
                (selectionChange)="selectionChange($event)">
                <ng-template let-column let-index="index" pTemplate="item">
                    <div role="listitem" class="column-container">
                        <div class="col move">
                            <button
                                [id]="'drag-column-btn-' + column.field"
                                pButton
                                tabindex="0"
                                class="p-button-secondary btn-drag"
                                [ariaLabel]="'Drag Button'">
                                <i class="fa-solid fa-grip-lines"></i>
                            </button>
                        </div>
                        <div class="col name">
                            <span [tabIndex]="0" class="column-name">
                                <span class="order-badge">{{ index + 1 }}</span>
                                {{ column.name | translate }}
                            </span>
                        </div>
                        <div class="col sort">
                            <button
                                [id]="'sort-column-btn-' + column.field"
                                pButton
                                tabindex="0"
                                class="p-button-secondary btn-sort"
                                [ariaLabel]="'Sort Button'"
                                [pTooltip]="
                                    (column.sortOrder === sortOrders.DESC
                                        ? 'tableSettings.sortBy.sortAscending'
                                        : 'tableSettings.sortBy.sortDescending'
                                    ) | translate
                                "
                                [tooltipPosition]="'left'"
                                (click)="changeSortOrder(column)"
                                (keydown.enter)="changeSortOrder(column)">
                                @if (column.numericalSort) {
                                    @if (column.sortOrder === sortOrders.DESC) {
                                        <i class="fa-solid fa-arrow-down-9-1"></i>
                                    }
                                    @if (column.sortOrder === sortOrders.ASC) {
                                        <i class="fa-solid fa-arrow-down-1-9"></i>
                                    }
                                } @else {
                                    @if (column.sortOrder === sortOrders.DESC) {
                                        <i class="fa-solid fa-arrow-down-z-a"></i>
                                    }
                                    @if (column.sortOrder === sortOrders.ASC) {
                                        <i class="fa-solid fa-arrow-down-a-z"></i>
                                    }
                                }
                            </button>
                        </div>
                        @if (canRemoveColum) {
                            <div class="col remove">
                                <button
                                    [id]="'remove-column-btn-' + column.field"
                                    pButton
                                    tabindex="0"
                                    class="p-button-secondary btn-remove"
                                    [ariaLabel]="'tableSettings.sortBy.removeColumnsButton.ariaLabel' | translate"
                                    [pTooltip]="'tableSettings.sortBy.removeSortingCriteria' | translate"
                                    [tooltipPosition]="'left'"
                                    (click)="removeColumn(column)"
                                    (keydown.enter)="removeColumn(column)">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        }
                    </div> </ng-template
            ></p-orderList>
        </div>
    </div>

    <div class="manage-visible-columns-container">
        <label id="manage-columns-label" for="manage-columns-multiselect">
            {{ 'tableSettings.sortBy.addColumns' | translate }}
        </label>
        <p-multiSelect
            id="manage-columns-multiselect"
            styleClass="filter-dropdown"
            optionValue="field"
            optionLabel="name"
            optionDisabled="isDisabled"
            display="chips"
            #columnsMultiselect
            ariaLabelledBy="manage-columns-multiselect"
            [selectedItemsLabel]="'tableSettings.sortBy.addColumnsPlaceholder' | translate"
            [showClear]="false"
            [(ngModel)]="selectedColumnsIds"
            [options]="columns"
            [selectionLimit]="columnsMaxLimit"
            [placeholder]="'tableSettings.sortBy.addColumnsPlaceholder' | translate"
            (onChange)="changeColumns(true)"
            (keydown.escape)="closeColumnsSelection($event)">
            <ng-template pTemplate="header">
                @if (selectedColumnsIds.length >= columnsMaxLimit) {
                    <p class="error-message">
                        {{ 'tableSettings.sortBy.addColumnsLimitError' | translate }}
                    </p>
                }
                <br />
            </ng-template>
            <ng-template pTemplate="selectedItems"
                ><p style="margin: 0">{{ 'tableSettings.sortBy.addColumnsPlaceholder' | translate }}</p>
            </ng-template>
            <ng-template let-column pTemplate="item">
                {{ column.name | translate }}
            </ng-template>
        </p-multiSelect>
    </div>
</div>
